module.exports = __webpack_public_path__ + "assets/f2030043f75c0b8eb087e86f7015a9ab.png";